// import { defaults } from "axios";
import { createContext, useContext } from "react";
import { useAuth } from "contexts/AuthContext";
import { useTranslation } from "react-i18next";

export const LEGISLATIVE_DRAFTING_UI_RULES = {
    stakeholder_forward_to_registrar: { value: "stakeholder_forward_to_registrar" },
    stakeholder_forward_to_head: { value: "stakeholder_forward_to_head" },
    stakeholder_forward_to_prosecutor: { value: "stakeholder_forward_to_prosecutor" },
    head_forward_to_director: { value: "head_forward_to_director" },
    director_forward_to_prosecutor: { value: "director_forward_to_prosecutor" },
    director_forward_to_coordinator: { value: "director_forward_to_coordinator" },
    edit_director_forward_to_coordinator: { value: "edit_director_forward_to_coordinator" },
    coordinator_forward_to_prosecutor: { value: "coordinator_forward_to_prosecutor" },
    edit_coordinator_forward_to_prosecutor: { value: "edit_coordinator_forward_to_prosecutor" },
    registrar_forward_to_coordinator: { value: "registrar_forward_to_coordinator" },
    coordinator_forward_to_head: { value: "coordinator_forward_to_head" },
    edit_head_forward_to_director: { value: "edit_head_forward_to_director" },
    head_forward_to_prosecutor: { value: "head_forward_to_prosecutor" },
    head_forward_to_coordinator: { value: "head_forward_to_coordinator" },
    coordinator_forward_to_registrar: { value: "coordinator_forward_to_registrar" },

    additional_info: { value: "additional_info" },
    additional_info_action: { value: "additional_info_action" },
    additional_info_forward_to_stakeholder: { value: "additional_info_forward_to_stakeholder" },
    edit_additional_info: { value: "edit_additional_info" },
    additional_info_stakeholder: { value: "additional_info_stakeholder" },
    additional_info_submitted: { value: "additional_info_submitted" },

    draft_non_essential: { value: "draft_non_essential" },
    draft_and_additional_file: { value: "draft_and_additional_file" },
    forward_darft: { value: "forward_darft" },
    forward_darft_to_director: { value: "forward_darft_to_director" },
    forward_darft_to_head: { value: "forward_darft_to_head" },

    public_and_amended: { value: "public_and_amended" },
    edit_audit_draft: { value: "edit_audit_draft" },
    audit_submitted: { value: "audit_submitted" },

    final_approval: { value: "final_approval" },
    publish: { value: "publish" },
    broadcasted: { value: "broadcasted" },
    archived: { value: "archived" },

    internal_ui: { value: "internal_ui" },

    prosecutor_forward_to_coordinator: { value: "prosecutor_forward_to_coordinator" },
    prosecutor_forward_to_director: { value: "prosecutor_forward_to_director" },
    edit_prosecutor_forward_to_coordinator: { value: "edit_prosecutor_forward_to_coordinator" },
    edit_reference_number: { value: "edit_reference_number" },

    advice_summary: { value: "advice_summary" },

    upload_audit_target: { label: "Upload Audit Target", value: "upload_audit_target" },
    upload_audit: { label: "Upload Audit", value: "upload_audit" },
    team_appointed: { label: "Team Appointed", value: "team_appointed" },
    identification_complete_forward: { label: "Identification Complete Forward", value: "identification_complete_forward" },

    approve_or_schedule: { label: "Approve or Schedule", value: "approve_or_schedule" },
    approve_or_respond: { label: "Approve or Respond", value: "approve_or_respond" },
    schedule_awareness: { label: "Schedule Awareness", value: "schedule_awareness" },
    awareness_outcome: { label: "Awareness Outcome", value: "awareness_outcome" },

    training_manual_approve: { label: "Training Manual Approve", value: "training_manual_approve" },
    training_manual_approved: { label: "Training Manual Approved", value: "training_manual_approved" },
    training_schedule: { label: "Training Schedule", value: "training_schedule" },
    training_feedback: { label: "Training Feedback", value: "training_feedback" },
    distribute_to_zone: { label: "Distribute to Zone", value: "distribute_to_zone" },

    edit_assigned_team: { label: "Edit Assigned Team", value: "edit_assigned_team" },
    edit_target_approve: { label: "Target Approve", value: "edit_target_approve" },
    respond_amended: { label: "Respond Amended", value: "respond_amended" },
    oagb_management_head_approve_respond: { label: "Management Approve or Respond", value: "oagb_management_head_approve_respond" },
}

export const VISIBILITY_RULES: Record<string, Record<string, Record<string, string[]>>> = {
    "internal_ui": {
        all: {
            all: ["GeneralAttorney", "LRDIFUDDirector", "LRDIFUDeputy", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"]
        }
    },

    "stakeholder_forward_to_registrar": {
        additional_info_submitted: {
            not_forwarded: [],
        },
        traning_request_submitted: {
            not_forwarded: [],
        },
    },
    stakeholder_forward_to_prosecutor: {
        additional_info_submitted: {
            not_forwarded: [],
        },
    },
    "additional_info_stakeholder": {
        "Waiting for Additional Information": {
            assigned_to_prosecutor: ["external"],
        },
        "additional_info_requested": {
            assigned_to_prosecutor: ["external"],
        },
        additional_info_submitted: {
            not_forwarded: [],
            "sent_to_registrar": [],
            "assigned_to_prosecutor": ["external"],
        },
    },
    "stakeholder_forward_to_head": {
        Submitted: {
            not_forwarded: [],
        },
        "Under review": {
            not_forwarded: [],
        },
        "Under Analysis": {
            not_forwarded: [],
        },
    },
    head_forward_to_prosecutor: {
        "draft_responded": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "pending": {
            "not_forwarded": ["GeneralAttorney", "LRDIFUDeputy"]
        }
    },
    head_forward_to_coordinator: {
        "draft_responded": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "identification_complete": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"]
        },
    },
    "head_forward_to_director": {
        "Submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under review": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Back to Head": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Final Approval": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
    },
    "edit_head_forward_to_director": {
        Submitted: {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under review": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
        "Back to Head": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy"]
        },
    },
    "director_forward_to_coordinator": {
        "Back to Head": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "director_forward_to_prosecutor": {
        "draft_responded": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "edit_director_forward_to_coordinator": {
        head_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        "Back to Head": {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
        // Director acting as head while the request sits at the head stage:
        // can write a remark and forward to a coordinator or set up the team.
        "Submitted": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
        "Under review": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
        "Under Analysis": {
            "forwarded_to_head": ["LRDIFUDDirector"]
        },
        // Coordinator sent the request back up with "Forward to Director"
        // (Legal Translation coordinatorRemark).
        coordinator_remark_submitted: {
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "coordinator_forward_to_prosecutor": {
        coordinator_remark_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "Back to Coordinator": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        additional_info_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "pending": {
            "not_forwarded": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"]
        },
        "session_scheduled": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        team_assigned: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
    },
    "coordinator_forward_to_registrar": {
    },
    "coordinator_forward_to_head": {
        audit_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"]
        },
        "identification_in_progress": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
            "forwarded_to_director": ["LRDIFUDDirector"]
        },
    },
    "edit_coordinator_forward_to_prosecutor": {
        director_remark_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "Back to Coordinator": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "all": {
            "all": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        "identification_complete": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
        letter_ref_no_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        team_assigned: {
            "team_assigned": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        internal_traning_request_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
        // Director responded back on a draft: it comes down to the coordinator,
        // who re-forwards it (with the director's file) to the experts.
        draft_responded: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"]
        },
    },
    "registrar_forward_to_coordinator": {
        additional_info_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
    },
    "prosecutor_forward_to_director": {
        "draft_non_ensential": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
    },
    "prosecutor_forward_to_coordinator": {
        Submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "additional_info_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "draft_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "public_and_amended_file_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "Draft Prepared": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        training_manual_submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        outcome_submitted: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
    },
    "identification_complete_forward": {
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "LRDIFUDeputy", "ZonalLIF"],
            "forwarded_to_head": ["LRDIFUDDirector", "LegalResearchCoordinator", "LRDIFUDeputy", "ZonalLIF"],
        },
    },
    // removed because of 2 forward buttons on legeslative draft law upload
    //edit_prosecutor_forward_to_coordinator: {
    //   "draft_submitted": {
    //      "assigned_to_prosecutor": ["LegalResearchProsecutor"]
    // }
    //},

    "additional_info": {
        "Waiting for Additional Information": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
            not_forwarded: ["external", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"]
        },
        "additional_info_responded": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
        additional_info_submitted: {
            assigned_to_prosecutor: ["external", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
            not_forwarded: []
        },
    },
    "additional_info_action": {
        "Waiting for Additional Information": {
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
            "assigned_to_prosecutor": ["LegalResearchProsecutor"]
        },
    },
    "additional_info_forward_to_stakeholder": {
        "Waiting for Additional Information": {
            "sent_to_registrar": ["LegalResearchCoordinator", "Registrar"],
        },
    },
    "edit_additional_info": {
        "Waiting for Additional Information": {
            not_forwarded: [],
            assigned_to_prosecutor: ["external"]
        },
        "additional_info_requested": {
            assigned_to_prosecutor: ["external"]
        },
        additional_info_submitted: {
            not_forwarded: []
        },
    },
    "additional_info_submitted": {
        additional_info_submitted: {
            all: ["stakeholder", "Registrar", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"]
        },
    },
    "draft_non_essential": {
        "draft_non_ensential": {
            all: ["stakeholder", "Registrar", "GeneralAttorney", "LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
            "forwarded_to_director": ["LRDIFUDDirector"],
        },
    },
    "draft_and_additional_file": {
        all: {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "pending": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "team_appointed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"]
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "session_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },

    "forward_darft": {
    },
    "forward_darft_to_director": {
        "draft_submitted": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "Draft Prepared": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "proposal_submitted": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
        "audit_completed": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "ZonalLIF"],
        },
    },
    "forward_darft_to_head": {
        "draft_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "Draft Prepared": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "proposal_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "audit_completed": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
        "public_and_amended_file_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    "edit_reference_number": {
        "Draft Approved": {
            "sent_to_registrar": ["Registrar"],
        },
        "Approved by LDCCM": {
            "sent_to_registrar": ["Registrar"],
        },
        "Approved by Head": {
            "sent_to_registrar": ["Registrar"],
        },
        cafffee_aproval: {
            "sent_to_registrar": ["Registrar"],
            "forwarded_to_director": ["Registrar"],
        },
        traning_request_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
        internal_traning_request_submitted: {
            "sent_to_registrar": ["Registrar"],
        },
        "Final Approval": {
            "sent_to_registrar": ["Registrar"],
        },
        "finalization_complete": {
            "sent_to_registrar": ["Registrar"],
        },
        "letter_refnum_submitted": {
            "forwarded_to_director": ["Registrar"],
        },
        "completed": {
            "forwarded_to_director": ["Registrar"],
        },
        "forwarded_to_director": {
            "forwarded_to_director": ["Registrar"],
        },
    },
    /*"public_and_amended": {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "letter_refnum_submitted": {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    "assigned_to_prosecutor": ["LegalResearchProsecutor"],
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    },
    }, retired due to the new change saying coordinator uploads public, ammended & audit*/

    "public_and_amended": {
        "allow_public_feedback": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
    },

    "edit_audit_draft": {
        "public_and_amended_file_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        },
    },

    "final_approval": {
        "audit_submitted": {
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    "oagb_management_head_approve_respond": {
        "audit_completed": {
            "forwarded_to_management": ["OAGBManagementHead"]
        }
    },

    "publish": {
        "archived": {
            "forwarded_to_director": ["LRDIFUDDirector", "ZonalLIF"],
        }
    },
    "archived": {
        "archived": {
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"],
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"],
        }
    },
    "broadcasted": {
        "Published": {
            not_forwarded: ["GeneralAttorney", "LegalResearchCoordinator", "LegalResearchProsecutor", "ZonalLIF"]
        }
    },
    "upload_audit_target": {
        "identification_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "pending": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "summary_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    "team_appointed": {
        "team_appointed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_submitted": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "proposal_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    "upload_audit": {
        "audit_in_progress": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_completed": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
        "audit_responded": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor", "ZonalLIF"],
        },
    },
    approve_or_schedule: {
        "summary_approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
        outcome_submitted: {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        }
    },

    approve_or_respond: {
        "summary_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector"],
            "forwarded_to_director": ["LRDIFUDDirector"],
        },
    },
    schedule_awareness: {
        "summary_approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        }
    },
    awareness_outcome: {
        "session_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
    },

    training_manual_approve: {
        "training_manual_submitted": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
    },

    training_manual_approved: {
        "approved": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator"],
        },
    },
    training_schedule: {
        "training_scheduled": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LegalResearchProsecutor"],
        },
        "all": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LegalResearchProsecutor"],
        }
    },
    training_feedback: {
        "training_scheduled": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
        },
        "final": {
            "assigned_to_prosecutor": ["LegalResearchProsecutor"],
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator", "LegalResearchProsecutor"],
        },
    },
    distribute_to_zone: {
        summary_approved: {
            "forwarded_to_coordinator": ["LRDIFUDDirector", "LegalResearchCoordinator"],
        },
    },
    edit_assigned_team: {
        "director_remark_submitted": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"],
        },
        "coordinator_remark_submitted": {
            "assigned_to_prosecutor": ["LRDIFUDDirector", "LegalResearchCoordinator", "ZonalLIF"],
        },
    },
    edit_target_approve: {
        "identification_in_progress": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "LRDIFUDeputy", "ZonalLIF"],
            "forwarded_to_head": ["GeneralAttorney", "LRDIFUDeputy", "ZonalLIF"],
        },
    },

    respond_amended: {
        "audit_responded": {
            "forwarded_to_coordinator": ["LegalResearchCoordinator", "LRDIFUDDirector", "ZonalLIF"],
        }
    },
};

// Module-specific roles that act like the generic research roles in the
// shared VISIBILITY_RULES. Legal Translation has its own coordinator/prosecutor
// roles, and awareness/follow-up prosecutors are put on mixed teams by the
// director, so they need the same team-member actions.
export const ROLE_ALIASES: Record<string, string[]> = {
    LegalTranslationCordinator: ["LegalResearchCoordinator"],
    LegalTranslationProsecutor: ["LegalResearchProsecutor"],
    ImpAwarenessProsecutor: ["LegalResearchProsecutor"],
};

export function expandRoles(roles: string[] = []): string[] {
    const expanded = new Set(roles);
    roles.forEach((r) => ROLE_ALIASES[r]?.forEach((a) => expanded.add(a)));
    return Array.from(expanded);
}

// Roles that oversee a module's work and see every request in it.
export const OVERSIGHT_ROLES = [
    "LegalResearchCoordinator",
    "ImpAwarenessCordinator",
    "LRDIFUDDirector",
    "LRDIFUDeputy",
    "GeneralAttorney",
    "OAGBManagementHead",
    "Registrar",
];

// A prosecutor (any prosecutor role) without an oversight role: sees and acts
// only on the requests whose team they are on.
export function isTeamScopedUser(roles: string[] = []): boolean {
    return expandRoles(roles).includes("LegalResearchProsecutor") &&
        !roles.some((r) => OVERSIGHT_ROLES.includes(r));
}

// The user's entry on a request's team. Modules store the member as
// prosecutor_user_id, prosecutor_id (training, awareness) or user_id (follow-up).
function teamEntries(assignments: any[] | undefined, user: any): any[] {
    const uid = String(user?.user_id ?? user?.id ?? "");
    if (!uid) return [];
    return (assignments || []).filter(
        (a) => String(a?.prosecutor_user_id ?? a?.prosecutor_id ?? a?.user_id ?? "") === uid,
    );
}

// True when the user is on the request's team, leader or member.
export function isTeamMember(assignments: any[] | undefined, user: any): boolean {
    return teamEntries(assignments, user).length > 0;
}

// True when the user leads the request's team (is_team_leader, or role "leader").
export function isTeamLeader(assignments: any[] | undefined, user: any): boolean {
    return teamEntries(assignments, user).some(
        (a) => a?.is_team_leader === true || a?.is_team_leader === "true" || a?.role === "leader",
    );
}

const PROSECUTOR_ROLES = ["LegalResearchProsecutor", "ImpAwarenessProsecutor", "LegalTranslationProsecutor"];

// The team of the request on screen. A detail page wraps its panels in
// <TeamScope team={...}> so the prosecutor actions inside go to the team
// leader only: members still view the request but get no action buttons.
const TeamContext = createContext<any[] | null>(null);

export function TeamScope({ team, children }: { team?: any[]; children: React.ReactNode }) {
    return (
        <TeamContext.Provider value={team || []}>
            <TeamMemberNotice team={team} />
            {children}
        </TeamContext.Provider>
    );
}

// Tells a team member who is not the leader why they have no action buttons:
// they view the request and write feedback in the right panel.
export function TeamMemberNotice({ team }: { team?: any[] }) {
    const { t } = useTranslation();
    const contextData = useAuth();
    const user = contextData?.user;
    if (!isTeamScopedUser(user?.roles || []) || !isTeamMember(team, user) || isTeamLeader(team, user)) return null;
    return (
        <div className="mx-2 mb-3 flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
            <svg className="mt-0.5 h-5 w-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p>{t("TeamMemberFeedbackOnly")}</p>
        </div>
    );
}

// The user's roles for the request on screen: inside a TeamScope, a prosecutor
// (without an oversight role) who is not the team leader loses the prosecutor
// roles, so prosecutor-only actions are hidden from them.
export function teamRoles(user: any, team: any[] | null): string[] {
    const roles: string[] = user?.roles || [];
    const expanded = expandRoles(roles);
    if (team === null || !isTeamScopedUser(roles) || isTeamLeader(team, user)) return expanded;
    return expanded.filter((r) => !PROSECUTOR_ROLES.includes(r));
}

// teamRoles for the current user and the request on screen.
export function useTeamRoles(): string[] {
    const contextData = useAuth();
    const team = useContext(TeamContext);
    return teamRoles(contextData?.user, team);
}

// List rows a user may see: a team-scoped prosecutor only the requests they are
// on the team of, everyone else all rows.
export function teamScopedRows<T>(rows: T[] | undefined, user: any): T[] {
    if (!isTeamScopedUser(user?.roles || [])) return rows || [];
    return (rows || []).filter((row: any) => isTeamMember(row?.prosecutor_assignments, user));
}

export function CanShow(
    ui_key: string,
    currentStatus: string,
    forwardStatus?: string,
): boolean {
    const contextData = useAuth();
    const team = useContext(TeamContext);
    const userRoles = teamRoles(contextData?.user, team);
    const userType = contextData?.user?.user_type;

    const forwardKey = forwardStatus || "none";
    const forwardRules = VISIBILITY_RULES[ui_key]?.[currentStatus]?.[forwardKey];

    if (!forwardRules) return false;


    if (userType === "external") {
        return forwardRules.length === 0 || 
               !!forwardRules.some(role => role.includes("stakeholder")) ||
               !!forwardRules.some(role => role === "external");
    }
    return forwardRules.some(role => 
        userRoles.some((userRole: string) => userRole.toLowerCase() === role.toLowerCase())
    );
}

export default function ShowUI({ ui_key, currentStatus, forwardStatus, children }: any) {
    return CanShow(ui_key, currentStatus, forwardStatus) ? children : null;
}
